module.exports = __webpack_public_path__ + "media/images/demo/compact-menu-a311d234ec700f395880862120c433a1.jpg";